import React, { useEffect } from "react"
import Prism from 'prismjs';

export default function CodeBlock({ block }) {
    const languageDict = block.blocks.find(block => {
        return (block.field === "language")
    })
    const languageClassName = "language-" + languageDict.rawValue
    const codeDict = block.blocks.find((block) => {
        return (block.field === "code")
    })

    useEffect(() => {
      Prism.highlightAll()
    })

    return (
        <pre>
            <code className={languageClassName}>
                {codeDict.rawValue}
            </code>
        </pre>
    )
}
